<!--
Author: Liubo
Date: 2018-10-12
Desc: 前端日志组件
-->
<template>
    <div v-if="showLog" class="comp-log comp">
        <div class="debugger" v-on:click="toggleLogPanel">
            <i class="fa fa-laptop" />
        </div>
        <logPanel v-if="showLogPanel" />
    </div>
</template>

<script>
import logPanel from "@/components/misc/logPanel.vue";
export default {
    components: {
        logPanel
    },
    data () {
        return {
            titText: "",
            showLog: process.env.NODE_ENV === "development",
            showLogPanel: false
        };
    },
    methods: {
        toggleLogPanel () {
            this.showLogPanel = !this.showLogPanel;
        }
    }
};
</script>
<style lang="scss">
.comp-log{
  .debugger{
    width: 48px;
    height:48px;
    border-radius: 24px;
    background: #66cc66;
    color: #fff;
    font-size: 24px;
    text-align:center;
    line-height:48px;
    position:fixed;
    right: 10px;
    bottom: 10px;
    cursor: pointer;
    z-index:99999;
    &:hover{
      background:#fff;
      color:#66cc66;
    }
  }
  .comp-logPanel{
    position: fixed;
    width: 100vw;
    height:35vh;
    bottom:0;
    left: 0;
    background:#fff;
    overflow:hidden;
    border:1px solid #ccc;
    z-index:99998;
  }
}
</style>
